import { Link } from "react-router-dom";
import type { BizPost } from "@/lib/types";
import { mediaUrl } from "@/lib/media";

interface PromoCardProps {
  post: BizPost;
}

function shortDate(value?: string): string {
  if (!value) return "";
  const str = String(value).replace(" ", "T");
  const d = new Date(str);
  if (Number.isNaN(d.getTime())) return value;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}.${m}.${day}`;
}

// 직업홍보 목록 카드
export default function PromoCard({ post }: PromoCardProps) {
  const w = post.writer;
  const writerName =
    [w?.name, w?.aho].filter(Boolean).join(" ") ||
    [post.name, post.aho].filter(Boolean).join(" ");
  const bizName = post.biz_name || w?.biz_name || "";
  const tel = String(post.tel ?? "").trim();
  const regdate = shortDate(post.regdate || post.reg_date);

  return (
    <article className="flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
      <Link to={`/promo/${post.no}`} className="group block">
        <div className="relative h-44 w-full overflow-hidden bg-background-100">
          {post.thumb ? (
            <img
              src={mediaUrl(post.thumb)}
              alt={post.subject}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-secondary-100">
              <span className="font-heading text-3xl font-bold text-secondary-800">
                {(bizName || post.subject || "홍보").slice(0, 1)}
              </span>
            </div>
          )}
          {post.is_top === 1 && (
            <span className="absolute left-3 top-3 rounded-full bg-secondary-500 px-3 py-1 text-[11px] font-bold text-primary-950">
              추천
            </span>
          )}
        </div>
        <div className="p-4">
          <h3 className="line-clamp-2 font-heading text-base font-bold text-foreground-950">
            {post.subject}
          </h3>
          {post.summary && (
            <p className="mt-1.5 line-clamp-2 text-sm text-foreground-600">{post.summary}</p>
          )}
        </div>
      </Link>

      <div className="mt-auto flex items-center justify-between gap-2 border-t border-background-200 px-4 py-3">
        <div className="min-w-0">
          {writerName && (
            <p className="truncate text-xs font-medium text-foreground-700">{writerName}</p>
          )}
          <p className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[11px] text-foreground-400">
            {regdate && <span>{regdate}</span>}
            <span className="inline-flex items-center gap-1">
              <i className="ri-eye-line" aria-hidden="true"></i>
              {post.hit ?? 0}
            </span>
          </p>
        </div>
        {tel && (
          <a
            href={`tel:${tel.replace(/[^0-9+]/g, "")}`}
            aria-label="전화 걸기"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-3.5 py-1.5 text-xs font-semibold text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-phone-line" aria-hidden="true"></i>
            전화
          </a>
        )}
      </div>
    </article>
  );
}